export default "__VITE_ASSET__nNbtUdEM__"